module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "saml-starter"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title
    }
  }), _c('form', {
    staticClass: "w-login-form w-login-form--sso",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_vm._m(0)]), _c('div', {
    staticClass: "w-page-footer"
  }, [(_vm.allowStandardLogin) ? _c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setLoginState', 'standard')
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Standard login")])]) : _vm._e()])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Single Sign On")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69676b66","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Login/SAMLStarter/SAMLStarter.vue
// module id = 604
// module chunks = 1